module.exports = __webpack_public_path__ + "img/113d7574349e4881b2e9b6d1b57ee1fe.a4a5189d.jpg";